import {
  Button,
  Dialog,
  DialogContent,
  Toolbar,
  IconButton,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Box,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import Import from "./ImportTab";
import COAPreference from "./COAPreferenceTab";
import UndoImport from "./UndoImportTab";
import { Form, useRouteLoaderData } from "react-router-dom";
import { Formik, useFormikContext } from "formik";
import { enqueueSnackbar } from "notistack";
import {
  DateFormater,
  Loader,
} from "../../../../../HelperFunctions/HelperFunctions";
import {
  accounts,
  GetDailyConfigAccounts,
  getPCS,
  userApproval,
} from "../../../../../API/nimbleAPI";
import {
  fetchUndoImport,
  getUserConfig,
  importMerchantFiles,
} from "../../../../../API/backendAPI";

const ImportDialog = ({
  open,
  headerCorporation,
  onClose,
  corp,
  setImportLoading,
  userPreference,
  setRestartSSE,
}) => {
  const { clientId, userId, Previlage, journal, Status } =
    useRouteLoaderData("reconciliation");
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Import");
  const [undoResult, setUndoResult] = useState(null);
  const [undoDialogOpen, setUndoDialogOpen] = useState(false);
  const [isCOACompleted, setIsCOACompleted] = useState(false);

  const [profitCenter, setProfitCenter] = useState([
    { ID: "select", Name: "-Select-" },
  ]);
  const [bankAcc, setBankAcc] = useState([
    { AccountID: "select", AccountName: "Select account" },
  ]);
  const [undoBankAcc, setUndoBankAcc] = useState([
    { AccountID: "select", AccountName: "Select account" },
  ]);
  const [selectedCorp, setSelectedCorp] = useState(corp.ID || "select");
  const [COABankDetails, setCOABankDetails] = useState([
    { ID: "select", Name: "Select account" },
  ]);

  const UserPref = userPreference.IsShowCorpLegalName;

  //   const journal = {
  //     "MenuID": "010000000000000000000000000000000357",
  //     "Create": false,
  //     "View": true,
  //     "Update": true,
  //     "Delete": true
  // } 

  // console.log("this is journal from import dialog",journal)

  const initialValues = {
    selectedCorp: selectedCorp,
    selectedProfitCenter: "select",
    selectedProfitCenterName: "",
    selectedBankAcc: "select",
    selectedBankAccName: "",
    files: [{ provider: "", batchFile: null, chargebackFile: null }],
    chargebacksAdjustmentAccount: "select",
    feeAdjustmentAccount: "select",
    excessMerchantAccount: "select",
    undoInfo: {
      undoSelectedProfitCenter: "select",
      undoSelectedBankAcc: "select",
      undoSelectedBankAccName: "select",
    },
  };

  const [defaults, setDefaults] = useState(initialValues);

  useEffect(() => {
    if (
      defaults.chargebacksAdjustmentAccount !== "select" &&
      defaults.feeAdjustmentAccount !== "select" &&
      defaults.excessMerchantAccount !== "select"
    ) {
      setIsCOACompleted(true);
    } else {
      setIsCOACompleted(false);
    }
  }, [defaults]);

  useEffect(() => {
    getProfitCentersAndBankDetails();
  }, [selectedCorp]);

  const getProfitCentersAndBankDetails = async () => {
    try {
      setLoading(true);
      try {
        const getPreviousSelections = await getUserConfig(selectedCorp, userId);
        if (getPreviousSelections.status === 200) {
          const {
            bank_id,
            bank_account_name,
            profit_center_id,
            profit_center_name,
            chargeback_adj_acc,
            fee_adj_acc,
            excess_merchant_acc,
            merchant_providers,
          } = getPreviousSelections.data;

          // Create a file row for each saved merchant provider, or default to one empty row
          const defaultFiles =
            merchant_providers?.length > 0
              ? merchant_providers.map((provider) => ({
                provider,
                batchFile: null,
                chargebackFile: null,
              }))
              : [{ provider: "", batchFile: null, chargebackFile: null }];

          setDefaults({
            ...initialValues,
            selectedProfitCenter: profit_center_id || "select",
            selectedProfitCenterName: profit_center_name || "",
            selectedBankAcc: bank_id || "select",
            selectedBankAccName: bank_account_name || "",
            chargebacksAdjustmentAccount: chargeback_adj_acc || "select",
            feeAdjustmentAccount: fee_adj_acc || "select",
            excessMerchantAccount: excess_merchant_acc || "select",
            files: defaultFiles,
          });
        }
      } catch (error) {
        if (error.status === 402) {
          console.log(error);
        } else {
          enqueueSnackbar("Error while getting Import details", {
            variant: "error",
          });
          return;
        }
      }

      const getPCSData = await getPCS(selectedCorp);
      setProfitCenter(getPCSData);
      if (getPCSData.length === 2) {
        setDefaults((prev) => ({
          ...prev,
          undoInfo: {
            ...prev.undoInfo,
            undoSelectedProfitCenter: getPCSData[1].ID,
          },
        }));

        if (defaults.selectedProfitCenter === "select") {
          setDefaults((prev) => ({
            ...prev,
            selectedProfitCenter: getPCSData[1].ID,
            selectedProfitCenterName: getPCSData[1].Name,
          }));
        }
      }

      const COAaccountType = "000000000000000000000000000000000000";
      const COABankAccList = await accounts(COAaccountType, selectedCorp);
      let AccountPayableTypeID = "0FA700000000000000000000000000000012";
      let AccountReceivblesTypeID = "0FA700000000000000000000000000000004";
      const removeIdslist = COABankAccList.filter(
        (obj) =>
          obj.AccountTypeID !== AccountPayableTypeID &&
          obj.AccountTypeID !== AccountReceivblesTypeID,
      );
      const validIds = new Set(removeIdslist.map(item => String(item.ID)));

      setDefaults(prev => ({
        ...prev,
        chargebacksAdjustmentAccount: validIds.has(String(prev.chargebacksAdjustmentAccount))
          ? prev.chargebacksAdjustmentAccount
          : "select",

        feeAdjustmentAccount: validIds.has(String(prev.feeAdjustmentAccount))
          ? prev.feeAdjustmentAccount
          : "select",

        excessMerchantAccount: validIds.has(String(prev.excessMerchantAccount))
          ? prev.excessMerchantAccount
          : "select",
      }));
      setCOABankDetails(removeIdslist);
    } catch (error) {
      if (error.status === 402) {
        return;
      } else {
        enqueueSnackbar("Error while getting Import details", {
          variant: "error",
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setImportLoading(true);

    let formData;

    try {
      const {
        selectedCorp,
        selectedProfitCenter,
        selectedBankAcc,
        selectedBankAccName,
        chargebacksAdjustmentAccount,
        feeAdjustmentAccount,
        excessMerchantAccount,
        userPreference,
      } = values;

      // const { Status } = await userApproval();
      // const Status = 2;

      const hasBatchFile = values.files.some((row) => row.batchFile);
      const hasChargebackFile = values.files.some((row) => row.chargebackFile);

      // if ((hasBatchFile || hasChargebackFile) && Status !== 3) {
      //   enqueueSnackbar("The user doesn't have upload privileges to upload the transactions", {
      //     variant: "warning",
      //   });
      //   return;
      // }

      const validations = [
        ...(profitCenter.length > 1
          ? [
            {
              valid:
                selectedProfitCenter && selectedProfitCenter !== "select",
              msg: "Profit center should be selected",
            },
          ]
          : []),
        {
          valid: selectedBankAcc && selectedBankAcc !== "select",
          msg: "Bank account should be selected",
        },
        {
          valid: !values.files.find((row) => !row.provider),
          msg: "Each row must have a provider",
        },
        {
          valid: values.files.some(
            (row) => row.batchFile || row.chargebackFile,
          ),
          msg: "At least one file is required",
        },
        {
          valid:
            chargebacksAdjustmentAccount &&
            chargebacksAdjustmentAccount !== "select",
          msg: "Chargebacks Adjustment account should be selected",
        },
        {
          valid: feeAdjustmentAccount && feeAdjustmentAccount !== "select",
          msg: "Fee Adjustment account should be selected",
        },
        {
          valid: excessMerchantAccount && excessMerchantAccount !== "select",
          msg: "Excess merchant account should be selected",
        },
      ];

      const failed = validations.find((v) => !v.valid);
      if (failed) {
        enqueueSnackbar(failed.msg, { variant: "warning" });
        return;
      }

      // --------- FORMDATA ---------
      formData = new FormData();

      formData.append("client_id", clientId);
      formData.append("corporation_id", selectedCorp);
      formData.append(
        "profit_center_id",
        selectedProfitCenter !== "select" ? selectedProfitCenter : "",
      );

      // Get profit center name from profitCenter array
      const profitCenterObj = profitCenter.find(
        (pc) => pc.ID === selectedProfitCenter,
      );
      const pcName =
        profitCenterObj?.Name && profitCenterObj.Name !== "-Select-"
          ? profitCenterObj.Name
          : "";
      formData.append("profit_center_name", pcName);

      formData.append("bank_account_id", selectedBankAcc);
      const bankAccObj = bankAcc.find(
        (acc) => acc.AccountID === selectedBankAcc,
      );
      formData.append("bank_account_name", bankAccObj?.AccountName || "");

      formData.append("chargeback_adj_acc", chargebacksAdjustmentAccount);
      formData.append("fee_adj_acc", feeAdjustmentAccount);
      formData.append("excess_merchant_acc", excessMerchantAccount);
      formData.append("user_id", userId);
      formData.append("dbname", corp.Name || "");
      formData.append("legalname", corp.LegalName || "");

      values.files.forEach((row) => {
        if (row.batchFile) {
          formData.append("batch_files", row.batchFile);
        }

        if (row.chargebackFile) {
          if (row.provider === "Chase" && Array.isArray(row.chargebackFile)) {
            row.chargebackFile.forEach((file) => {
              formData.append("charge_back_files", file);
              formData.append("merchant_provider", row.provider);
            });
          } else {
            formData.append("charge_back_files", row.chargebackFile);
            formData.append("merchant_provider", row.provider);
          }
        } else {
          formData.append("merchant_provider", row.provider);
        }
      });
      setRestartSSE((prev) => !prev);

      // --------- UI ACTIONS ---------
      onClose();
    } catch (error) {
      enqueueSnackbar("Error while Import", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }

    // --------- SSE CALL ---------
    try {
      const promise = await importMerchantFiles(formData);

      const errorPromise = promise?.error?.detail;

      if (errorPromise?.status_code === 400) {
        enqueueSnackbar(errorPromise?.details, { variant: "warning" });
      }
      if (errorPromise?.status_code === 409) {
        enqueueSnackbar(errorPromise?.details, { variant: "warning" });
      }

      const validatePromise = promise.data;
      const status = validatePromise[0].result.status;

      // console.log("this is from validate", validatePromise);

      // if (validatePromise[0].status_code === 409) {
      //   enqueueSnackbar(validatePromise[0].error, { variant: "warning" });
      // }
      // if (validatePromise[0].status_code === 400) {
      //   enqueueSnackbar(validatePromise[0].error, { variant: "warning" });
      // }
      // if (validatePromise[0].status_code === 500) {
      //   enqueueSnackbar(validatePromise[0].error, { variant: "error" });
      // }

      if (status === 200) {
        enqueueSnackbar(validatePromise[0].result.message, {
          variant: "success",
        });
      }
      // if (validatePromise[0].status_code === 400) {
      //   enqueueSnackbar(validatePromise[0].error, { variant: "warning" });
      // }
      // if (validatePromise[0].status_code === 500) {
      //   enqueueSnackbar(validatePromise[0].error, { variant: "error" });
      // }
    } catch (err) {
      console.error("Import SSE sync error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleUndoImport = async (corpId, values) => {
    if (Status !== 3) {
      enqueueSnackbar("You don't have delete privileges to undo the transactions", { variant: "warning" });
      return;
    }

    // console
    if (journal?.Create !== true) {
      enqueueSnackbar("The user doesn't have journal entry delete privileges to undo the transactions", {
        variant: "error",
      });
      return;
    }

    const hasChargebacks = values.selectedOptions?.includes("chargebacks");
    const hasOpen = values.selectedOptions?.includes("open");
    const hasMatched = values.selectedOptions?.includes("matched");
    const hasOpenOrMatched = hasOpen || hasMatched;
    const isChargebacksAlone = hasChargebacks && !hasOpen && !hasMatched;

    const validations = [
      ...(profitCenter.length > 1
        ? [
          {
            valid:
              values.undoSelectedProfitCenter &&
              values.undoSelectedProfitCenter !== "select",
            msg: "Profit center should be selected",
          },
        ]
        : []),
      {
        valid: values.MerchantProvider && values.MerchantProvider !== "select",
        msg: "merchant must be selected",
      },
      {
        valid:
          values.undoSelectedBankAcc && values.undoSelectedBankAcc !== "select",
        msg: "Bank account should be selected",
      },

      {
        valid:
          Array.isArray(values.dateRange) &&
          values.dateRange.length === 2 &&
          values.dateRange[0] instanceof Date &&
          values.dateRange[1] instanceof Date &&
          values.dateRange[0] <= values.dateRange[1],
        msg: "Valid date range must be selected",
      },
      {
        valid: values.selectedOptions && values.selectedOptions.length > 0,
        msg: "Please select at least one option (Open batch, Matched, or Chargebacks)",
      },
      {
        valid:
          isChargebacksAlone ||
          !hasOpenOrMatched ||
          (hasOpenOrMatched && (values.selectedCards || []).length > 0),
        msg: "At least one card must be selected when Open batch or Matched is selected",
      },
    ];
    const failed = validations.find((v) => !v.valid);
    if (failed) {
      enqueueSnackbar(failed.msg, { variant: "warning" });
      return;
    }

    setLoading(true);

    try {
      const cardsToSend = isChargebacksAlone ? [] : values.selectedCards || [];

      const payload = {
        from_date: DateFormater(values.dateRange[0]),
        to_date: DateFormater(values.dateRange[1]),
        user_id: userId,
        corporation_id: corpId,
        bank_account_id: values.undoSelectedBankAcc,
        pc_id:
          values.undoSelectedProfitCenter !== "select"
            ? values.undoSelectedProfitCenter
            : "",
        include_open_batch: values.selectedOptions.includes("open") ? 1 : 0,
        include_matched: values.selectedOptions.includes("matched") ? 1 : 0,
        include_chargebacks: values.selectedOptions.includes("chargebacks")
          ? 1
          : 0,
        cards: cardsToSend,
        MerchantProvider: values.MerchantProvider || null,
      };

      const data = await fetchUndoImport(payload);
      setUndoResult(data);
      setUndoDialogOpen(true);
      setRestartSSE((prev) => !prev);
    } catch (error) {
      enqueueSnackbar(error.response.data.detail, { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleUndoOk = () => {
    setUndoDialogOpen(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "80%",
          height: "95%",
        },
      }}
    >
      <Formik
        initialValues={defaults}
        enableReinitialize={true}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ submitForm, values }) => (
          <>
            <Toolbar
              sx={{
                bgcolor: "#d7d7d7",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  flex: 1,
                  color: "#1f1f1f",
                }}
                component="div"
                fontWeight={600}
                fontSize={"16px"}
              >
                Import
              </Typography>
              <Stack direction="row" spacing={2} alignItems="center">
                <Button
                  size="small"
                  type="submit"
                  disableRipple
                  disableElevation
                  variant="contained"
                  sx={{
                    px: 4,
                    textTransform: "none",
                    backgroundColor: "#b5dcf2",
                    color: "#000",
                  }}
                  onClick={() => {
                    // IMPORT TAB
                    if (selectedTab === "Import") {
                      if (isCOACompleted) {
                        submitForm();
                      } else {
                        setSelectedTab("COA Preference");
                      }
                      return;
                    }

                    if (selectedTab === "COA Preference") {
                      setIsCOACompleted(true);
                      submitForm();
                      return;
                    }

                    if (!Previlage?.[0]?.Delete) {
                      enqueueSnackbar(
                        "You do not have permission to undo imports.",
                        { variant: "error" },
                      );
                      return;
                    }
                    // if (journal?.Create !== true) {
                    //   enqueueSnackbar(
                    //     "You do not have permission for journal undo.",
                    //     {
                    //       variant: "error",
                    //     },
                    //   );
                    //   return;
                    // }

                    handleUndoImport(values.selectedCorp, values.undoInfo);
                  }}
                >
                  {selectedTab === "COA Preference" || selectedTab === "Import"
                    ? "Save & Close"
                    : "Undo import"}
                </Button>
                <IconButton
                  size="small"
                  edge="start"
                  onClick={onClose}
                  sx={{
                    backgroundColor: "#686868",
                    borderRadius: "50%",
                    ml: 0,
                  }}
                  disableRipple
                >
                  <CloseIcon sx={{ color: "white" }} />
                </IconButton>
              </Stack>
            </Toolbar>
            <Form style={{ overflow: "auto", height: "100%" }}>
              <DialogContent sx={{ padding: 1, height: "100%" }}>
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  gap={2}
                  height={"100%"}
                >
                  <ToggleButtonGroup
                    value={selectedTab}
                    exclusive
                    onChange={(e, newTab) => newTab && setSelectedTab(newTab)}
                  >
                    {["Import", "COA Preference", "Undo Import"].map((tab) => (
                      <ToggleButton
                        key={tab}
                        value={tab}
                        sx={{
                          p: "5px",
                          textTransform: "none",
                          whiteSpace: "nowrap",
                          px: 3,
                          fontSize: 13,

                          "&.Mui-selected": {
                            backgroundColor: "#bee9e9",
                            color: "black",
                          },
                          "&.Mui-selected:hover": {
                            backgroundColor: "#bee9e9",
                          },
                        }}
                      >
                        {tab}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                  <Box
                    sx={{
                      height: "100%",
                      overflow: selectedTab === "Import" ? "hidden" : "visible",
                    }}
                  >
                    {selectedTab === "Import" ? (
                      <Import
                        profitCenter={profitCenter}
                        bankAcc={bankAcc}
                        selectedCorp={selectedCorp}
                        loading={loading}
                        setLoading={setLoading}
                        setBankAcc={setBankAcc}
                        UserPref={UserPref}
                      />
                    ) : selectedTab === "COA Preference" ? (
                      <COAPreference accountList={COABankDetails} />
                    ) : (
                      <UndoImport
                        profitCenter={profitCenter}
                        undoBankAcc={undoBankAcc}
                        selectedCorp={selectedCorp}
                        loading={loading}
                        setLoading={setLoading}
                        setUndoBankAcc={setUndoBankAcc}
                        UserPref={UserPref}
                      />
                    )}
                  </Box>
                </Box>
              </DialogContent>
            </Form>
          </>
        )}
      </Formik>
      {loading && <Loader loading={loading} />}
      <Dialog
        open={undoDialogOpen}
        onClose={() => setUndoDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        sx={{
          zIndex: 1400,
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          },
        }}
      >
        <DialogContent sx={{ p: 3 }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            {/* Success Icon */}
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: "#e8f5e9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
              }}
            >
              <Typography fontSize={32}>✓</Typography>
            </Box>

            {/* Title */}
            <Typography
              fontWeight={600}
              fontSize={18}
              textAlign="center"
              color="#1f1f1f"
            >
              Undo Complete
            </Typography>

            {/* Message */}
            <Typography
              variant="body2"
              textAlign="center"
              color="text.secondary"
              sx={{ mb: 1 }}
            >
              {undoResult?.message || "Import Failed"}
            </Typography>

            {/* Stats Grid */}
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#f8f9fa",
                borderRadius: "8px",
                p: 2,
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 2,
              }}
            >
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Chargebacks Updated
                </Typography>
                <Typography fontWeight={600} fontSize={18}>
                  {undoResult?.chargebacks_updated ?? 0}
                </Typography>
              </Box>

              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Journal Updated
                </Typography>
                <Typography fontWeight={600} fontSize={18}>
                  {undoResult?.journal_updated ?? 0}
                </Typography>
              </Box>

              {/* <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Sales Transactions Updated
                </Typography>
                <Typography fontWeight={600} fontSize={18}>
                  {undoResult?.sales_transactions_updated ?? 0}
                </Typography>
              </Box> */}

              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Transactions Updated
                </Typography>
                <Typography fontWeight={600} fontSize={18}>
                  {undoResult?.transactions_updated ?? 0}
                </Typography>
              </Box>
            </Box>

            {/* OK Button */}
            <Button
              variant="contained"
              onClick={handleUndoOk}
              fullWidth
              sx={{
                mt: 1,
                py: 1.2,
                textTransform: "none",
                fontSize: 15,
                fontWeight: 500,
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "#1565c0",
                  boxShadow: "none",
                },
              }}
            >
              ok
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
};

export default ImportDialog;
